var map = {
	"./PMK.png": 2194,
	"./be-a-sponsor.png": 922,
	"./celcoin.png": 2195,
	"./cepeda.png": 2196,
	"./crdc.png": 2197,
	"./madrona.png": 2198,
	"./master.png": 2199,
	"./nuclea.png": 2200,
	"./oslo.png": 2201,
	"./ouro.png": 2202,
	"./singulare.png": 2203,
	"./tozzini.png": 2204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2193;